import React, { useEffect, useState } from 'react'
import { Snackbar } from '@mui/joy'
import { hideError } from '../slice/ErrorSlice'
import apiConfigured from '../slice/ApiSlice' // Import your store

const GlobalErrorHandler: React.FC = () => {
  const [showError, setShowError] = useState(false)

  useEffect(() => {
    const unsubscribe = apiConfigured.subscribe(() => {
      const state = apiConfigured.getState()
      setShowError(state.errorSlice.show)
    })

    return () => unsubscribe()
  }, [])

  const handleClose = () => {
    apiConfigured.dispatch(hideError())
  }

  return (
    <Snackbar
      autoHideDuration={3000}
      variant="soft"
      color="danger"
      open={showError}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      {'Hiba történt!'}
    </Snackbar>
  )
}

export default GlobalErrorHandler
